import React, { Component } from 'react';
import { TableTitleCell } from './MetricsTableTitleCell.styled';

interface ITableTitleCellProps {
   title: string;
   level: string;
}

export default class MetricsTableTitleCell extends Component<ITableTitleCellProps, {}> {
   public render() {
      const { title, level } = this.props;
      const formattedTitle = (title, level) => {
         switch (level) {
            case 'L1':
               return title;
            case 'L2':
               return '– ' + title;
            case 'L3':
               return '— ' + title;
            default:
               return title;
         }
      };

      return (
         <TableTitleCell colSpan={3} level={level}>
            {formattedTitle(title, level)}
         </TableTitleCell>
      );
   }
}
